import React, { useState, useEffect } from 'react';
import Title from '../../../Text/Title/Title';
import { Button, Col, Form, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import useApiRequests from '../../../../hooks/useApiRequests.tsx';
import { useNotification } from '../../../../hooks/useNotification';
import { IBoard } from '../../../../interfaces/IBoard.tsx';
import { useParams, useNavigate } from 'react-router-dom';
import MultipleValueTextInput from 'react-multivalue-text-input';

function Boards(): React.ReactElement {

	const { notify } = useNotification();
  const { id } = useParams();
  const { getBoardById, createNewBoard, updateBoard } = useApiRequests();
  const [board, setBoard] = useState<IBoard>({
    name: '',
		cols: [],
  });
	const [cols, setCols] = useState<any[]>([]);

	useEffect(() => {
  
    const getBoard = async () => {
      try{
        const boardData = await getBoardById(id||"");
        if(boardData.success){
          setBoard(boardData.data);
        }else{
          notify(boardData.msg, {type: "error"});
        }
      }catch(error){
        notify(error, {type: "error"});
      }
    };

    if(id !== "new"){
      getBoard();
    }
    
  }, []);


	//Funções
	const handleGoBack = () => {
			window.location.href = "/boards";
	};

	const handleUpdateBoard = async () => {
    try {
			board.cols = cols;
      const data = await createNewBoard(board);
      if(data.success){
        notify("Quadro atualizado com sucesso", {type: "success"});
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      notify(error, {type: "error"});
    }
  };

  const handleCreateBoard = async () => {
    try {
			board.cols = cols;
      const data = await createNewBoard(board);
      if(data.success){
        // console.log(data.data)
        notify("Quadro salvo com sucesso", {type: "success"});
        setTimeout(() => {
          window.location.href = `/board/edit/${data.data.id}`;
        }, 1000);
      }
    } catch (error) {
      notify(error, {type: "error"});
    }
  };


	return (
		<div className='page-container'>
				<div className='d-flex flex-wrap justify-content-between'>
						<div className="title-and-subtitle">
								<Title>Novo Quadro</Title>
						</div>
						<div className='d-flex gap-2'>
								<Button color="secondary" style={{height: "44px"}} onClick={() => handleGoBack()}>Voltar</Button>
								<Button color="success" style={{height: "44px"}} onClick={id == "new" ? handleCreateBoard : handleUpdateBoard}>Salvar</Button>
						</div>
				</div>
				<div className='mt-5 mb-5'>
					<Form>
						<Row>
							<Col md={6} lg={8}>
								<Label className='label bold'>
									Nome do Quadro
								</Label>
								<Input 
									type='text'
									placeholder='Nome do Quadro'
									value={board.name}
									onChange={(e) => setBoard({...board, name: e.target.value})}
								/>
							</Col>
						</Row>
						<Row className='mt-3'>
							<Col md={6} lg={8}>
								<Label className='label bold'>
									Colunas do Quadro
								</Label>
								<MultipleValueTextInput
									onItemAdded={(item, allItems) => setCols([...allItems])}
									onItemDeleted={(item, allItems) => setCols([...allItems])}
									values={board.cols}
									name="item-input"
									className='multi-value'
									placeholder="Adicione a coluna e aperte enter"
								/>
							</Col>
						</Row>
					</Form>
				</div>
		</div>
	);
}

export default Boards;
